export const BIGDATA_HOST = process.env.VUE_APP_BIGDATA_URL
// export const BIGDATA_HOST = 'https://x.test.cosmoplat.cn:5173'

export const BIGDATA_PATHS = {
  ontologyObj: `${BIGDATA_HOST}/cdh-public-ontology-model-manage`,
  ontologyMap: `${BIGDATA_HOST}/cdh-public-ontology-map-edit?isIframe=1`,
  datasource: `${BIGDATA_HOST}/cdh-public-datasource-manage`,
  blood: `${BIGDATA_HOST}/cdh-public-blood-map`,
  industryModel: `${BIGDATA_HOST}/cdh-public-industry-model-manage`,
  indicatorDefinition: `${BIGDATA_HOST}/cdh-public-indicator-definition`,
  indicatorDirectory: `${BIGDATA_HOST}/cdh-public-indicator-directory`,
  indicatorElement: `${BIGDATA_HOST}/cdh-public-indicator-element`,
  indicatorUnit: `${BIGDATA_HOST}/indicator-units`, // 计量单位
  indicatorLabels: `${BIGDATA_HOST}/indicator-labels`, // 标签管理
  industryIndicatorLibrary: `${BIGDATA_HOST}/cdh-public-industry-indicator-library`,
  intelligentIndicatorSystem: `${BIGDATA_HOST}/cdh-public-intelligent-indicator-system`,
  atomicIndicators: `${BIGDATA_HOST}/indicator-v2/atomic-indicators`, // 原子指标
  derivedIndicators: `${BIGDATA_HOST}/indicator-v2/derived-indicators`, // 派生指标
  compositeIndicators: `${BIGDATA_HOST}/indicator-v2/composite-indicators`, // 复合指标
  data: `${BIGDATA_HOST}/data`,
  dataSource: `${BIGDATA_HOST}/data-source`,
  offlineCollection: `${BIGDATA_HOST}/offline-collect/task-manage`,
  realTimeCollection: `${BIGDATA_HOST}/online-collect`,
  fileCollection: `${BIGDATA_HOST}/file-collect-task`,
  relationModel: `${BIGDATA_HOST}/relation-model`, // 关系模型
  metaCollect: `${BIGDATA_HOST}/meta-collect-manage`, // 元数据采集
  metaModels: `${BIGDATA_HOST}/meta-models`, // 元模型管理
  polymorphicMeta: `${BIGDATA_HOST}/polymorphic-meta`, // 多态元数据
  bloodAnalysis: `${BIGDATA_HOST}/blood-analysis`, // 数据血缘
  standardFile: `${BIGDATA_HOST}/standard-file`, // 标准文件
  standardList: `${BIGDATA_HOST}/standard-list`, // 标准定义
  standardRelation: `${BIGDATA_HOST}/standard-relation`, // 标准关联
  qualityWork: `${BIGDATA_HOST}/quality-work`, // 质量作业
  qualityTest: `${BIGDATA_HOST}/quality-test`, // 质量检测
  dataAuth: `${BIGDATA_HOST}/data-auth`, // 数据权限
  dataMaskingRules: `${BIGDATA_HOST}/data-masking-rules`, // 脱敏规则管理
  dataMaskingConfig: `${BIGDATA_HOST}/data-masking-config` // 脱敏规则关联

}

// 本体治理智能体 - 天数 数据治理菜单路径
export const BIGDATA_GOVERNANCE_MAP = [
  // {
  //   id: "relationModel",
  //   title: "关系模型",
  //   label: "关系模型",
  //   url: BIGDATA_PATHS.relationModel,
  //   filePath: 'D:\caochangkui\projects\cdh-web-2.0\src\views\dataAdminister\relationModel\index.vue'
  // },
  // {
  //   id: "metaCollect",
  //   title: "元数据采集",
  //   label: "元数据采集",
  //   url: BIGDATA_PATHS.metaCollect,
  //   filePath: 'D:\caochangkui\projects\cdh-web-2.0\src\views\dataAdminister\metaData\collectManage\index.vue'
  // },
  // {
  //   id: "metaModels",
  //   title: "元模型管理",
  //   label: "元模型管理",
  //   url: BIGDATA_PATHS.metaModels,
  //   filePath: 'D:\caochangkui\projects\cdh-web-2.0\src\views\dataAdminister\metaModels\index.vue'
  // },
  // {
  //   id: "polymorphicMeta",
  //   title: "多态元数据",
  //   label: "多态元数据",
  //   url: BIGDATA_PATHS.polymorphicMeta,
  //   filePath: 'D:\caochangkui\projects\cdh-web-2.0\src\views\dataAdminister\polymorphicMeta\index.vue'
  // },
  // {
  //   id: "bloodAnalysis",
  //   title: "数据血缘",
  //   label: "数据血缘",
  //   url: BIGDATA_PATHS.bloodAnalysis,
  //   filePath: 'D:\caochangkui\projects\cdh-web-2.0\src\views\dataAdminister\bloodAnalysis\index.vue'
  // },
  // {
  //   id: "standardFile",
  //   title: "标准文件",
  //   label: "标准文件",
  //   url: BIGDATA_PATHS.standardFile,
  //   filePath: 'D:\caochangkui\projects\cdh-web-2.0\src\views\dataAdminister\standardFile\index.vue'
  // },
  // {
  //   id: "standardList",
  //   title: "标准定义",
  //   label: "标准定义",
  //   url: BIGDATA_PATHS.standardList,
  //   filePath: 'D:\caochangkui\projects\cdh-web-2.0\src\views\dataAdminister\standardList\index.vue'
  // },
  // {
  //   id: "standardRelation",
  //   title: "标准关联",
  //   label: "标准关联",
  //   url: BIGDATA_PATHS.standardRelation,
  //   filePath: 'D:\caochangkui\projects\cdh-web-2.0\src\views\dataAdminister\standardRelation\index.vue'
  // },
  // {
  //   id: "qualityWork",
  //   title: "质量作业",
  //   label: "质量作业",
  //   url: BIGDATA_PATHS.qualityWork,
  //   filePath: 'D:\caochangkui\projects\cdh-web-2.0\src\views\dataAdminister\qualityWork\index.vue'
  // },
  // {
  //   id: "qualityTest",
  //   title: "质量检测",
  //   label: "质量检测",
  //   url: BIGDATA_PATHS.qualityTest,
  //   filePath: 'D:\caochangkui\projects\cdh-web-2.0\src\views\dataAdminister\qualityTest\index.vue'
  // },
  // {
  //   id: "dataAuth",
  //   title: "数据权限",
  //   label: "数据权限",
  //   url: BIGDATA_PATHS.dataAuth,
  //   filePath: 'D:\caochangkui\projects\cdh-web-2.0\src\views\dataAdminister\dataAuth\index.vue'
  // },
  // {
  //   id: "dataMaskingRules",
  //   title: "脱敏规则管理",
  //   label: "脱敏规则管理",
  //   url: BIGDATA_PATHS.dataMaskingRules,
  //   filePath: 'D:\caochangkui\projects\cdh-web-2.0\src\views\dataSecurity\dataMasking\index.vue'
  // },
  // {
  //   id: "dataMaskingConfig",
  //   title: "脱敏规则关联",
  //   label: "脱敏规则关联",
  //   url: BIGDATA_PATHS.dataMaskingConfig,
  //   filePath: 'D:\caochangkui\projects\cdh-web-2.0\src\views\dataSecurity\dataMasking\dataMaskingConfig.vue'
  // },
]
